import React from 'react';
import { Link } from 'react-router-dom';
import JobCreationForm from '../JobCreationForm/JobCreationForm';
import AutocompleteDropdown from '../AutocompleteDropdown/AutocompleteDropdown';

const PostJob = () => {
  return (

    <div className="js-pg-hg">
      <div className="container">
      <div className="d-lg-flex d-sm-block flex-row align-items-center justify-content-between">
          <div className='js-mn-title flex-grow-1'>
            <h2 className='fw-bold pb-2'>Post a Job <span class="badge ms-2 bg-light text-dark">Admin</span></h2>
            <p>Please fill below form to publish job post</p>
          </div>
          <div className="mt-0">
            <div className="form-group mb-4">
              <label for="New Password" className="form-label">Select Recruiters</label>
              <AutocompleteDropdown />
            </div>
          </div>
        </div>
      </div>
      <JobCreationForm />
    </div>
  );
};

export default PostJob;
